var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "system-mapping settings-container" },
    [
      _vm.canEdit
        ? _c(
            "HKLLeftRight",
            [
              _c("div"),
              _vm._v(" "),
              !_vm.isEditing
                ? _c("HKLButton", {
                    attrs: { color: "orange", action: "edit" },
                    on: {
                      click: function () {
                        return (_vm.isEditing = true)
                      },
                    },
                  })
                : _c(
                    "div",
                    [
                      _c("HKLButton", {
                        attrs: { color: "darkblue", action: "cancel" },
                        on: { click: _vm.cancel },
                      }),
                      _vm._v(" "),
                      _c("HKLButton", {
                        attrs: { color: "orange", action: "save" },
                        on: { click: _vm.save },
                      }),
                    ],
                    1
                  ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "clients-box" },
        [
          _c(
            "a-row",
            { attrs: { type: "flex", gutter: [16, 16] } },
            [
              _c("a-col", { attrs: { span: _vm.colClientSpan } }, [
                _c("label", { class: _vm.requireFlagClass }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("table.header.clientId")) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("a-col", { attrs: { span: _vm.colClientSpan } }, [
                _c("label", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm._f("capitalize")(_vm.$t("table.header.description"))
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("a-col", { attrs: { span: _vm.colTpSpan } }, [
                _c("label", { class: _vm.requireFlagClass }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("table.header.tenantProject")) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.isEditing ? _c("a-col", { attrs: { span: 2 } }) : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isEditing
            ? _vm._l(_vm.pendingClientData, function (item, index) {
                return _c(
                  "a-row",
                  { key: index, attrs: { type: "flex", gutter: [16, 16] } },
                  [
                    _c(
                      "a-col",
                      { attrs: { span: _vm.colClientSpan } },
                      [
                        _c("HKLInput", {
                          directives: [
                            {
                              name: "fusioninputcheck",
                              rawName: "v-fusioninputcheck",
                              value: {
                                required: true,
                                showTip: false,
                                patternOnly: _vm.validateClientId(item),
                              },
                              expression:
                                "{\n              required: true,\n              showTip: false,\n              patternOnly: validateClientId(item)\n            }",
                            },
                          ],
                          staticClass: "h42",
                          model: {
                            value: item.clientId,
                            callback: function ($$v) {
                              _vm.$set(item, "clientId", $$v)
                            },
                            expression: "item.clientId",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-col",
                      { attrs: { span: _vm.colClientSpan } },
                      [
                        _c("HKLTextarea", {
                          staticClass: "h42",
                          model: {
                            value: item.description,
                            callback: function ($$v) {
                              _vm.$set(item, "description", $$v)
                            },
                            expression: "item.description",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-col",
                      { attrs: { span: _vm.colTpSpan } },
                      [
                        _c("HKLMultiSelect", {
                          attrs: {
                            required: true,
                            showTip: false,
                            fusionInputCheckPattern:
                              _vm.multiSelectNotEmptyPattern,
                            options: _vm.getOptions(item),
                          },
                          on: {
                            focus: function ($event) {
                              return _vm.setFocusItem(item)
                            },
                          },
                          model: {
                            value: item.tenantProjects,
                            callback: function ($$v) {
                              _vm.$set(item, "tenantProjects", $$v)
                            },
                            expression: "item.tenantProjects",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isEditing
                      ? _c(
                          "a-col",
                          { attrs: { span: 2 } },
                          [
                            _c("HKLDeleteIcon", {
                              on: {
                                click: function ($event) {
                                  return _vm.removeClient(index)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              })
            : _vm._l(_vm.parsedClientData, function (item, index) {
                return _c(
                  "a-row",
                  { key: index, attrs: { type: "flex", gutter: [16, 16] } },
                  [
                    _c("a-col", { attrs: { span: _vm.colClientSpan } }, [
                      _c("div", [
                        _vm._v(
                          "\n            " +
                            _vm._s(item.clientId) +
                            "\n          "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("a-col", { attrs: { span: _vm.colClientSpan } }, [
                      _c("div", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("isEmptyValue")(item.description)) +
                            "\n          "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("a-col", { attrs: { span: _vm.colTpSpan } }, [
                      _c(
                        "ul",
                        _vm._l(item.displayTps, function (name, j) {
                          return _c("li", { key: index + "_" + j }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(name) +
                                "\n            "
                            ),
                          ])
                        }),
                        0
                      ),
                    ]),
                  ],
                  1
                )
              }),
          _vm._v(" "),
          _vm.isEditing
            ? _c(
                "div",
                {
                  staticClass: "underline pointer add-client-btn",
                  on: { click: _vm.addNewClient },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("settings.systemMapping.clientId")) +
                      " +\n    "
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }